import { Component } from '@angular/core';

@Component({
    selector:'paymentFailure',
    templateUrl:'paymentFailure.component.html'
})
export class PaymentFailureComponent{
    
}